import React from 'react';

import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
  Icon,
} from '@eluve/components';

export interface ErrorAlertProps {
  title?: string;
  message: string;
  reset?: () => void;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  title = 'Error',
  message,
  reset,
}) => {
  return (
    <Alert variant="destructive">
      <Icon name="AlertOctagon" size="xl" />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>
        {message}
        {reset ? (
          <Button
            onClick={reset}
            className="text-text-negative-subtle underline"
            variant="link"
          >
            Try again
          </Button>
        ) : null}
      </AlertDescription>
    </Alert>
  );
};
